import React from 'react'
import { css } from '@emotion/core'
import { boolAttr } from '@fs/zion-frontend-friends'
import useIsMobile from '../../hooks/useIsMobile'

const cardRowDesktopCss = css`
  display: grid;
  grid-template-columns: repeat(auto-fill, 250px);
  grid-gap: 24px;
  &[centered] {
    justify-content: center;
  }
`
const cardRowMobileCss = css`
  display: grid;
  grid-row-gap: 24px;
`

export default function CardRow({ children, centered = false }) {
  const isMobile = useIsMobile()
  return (
    <div css={isMobile ? cardRowMobileCss : cardRowDesktopCss} centered={boolAttr(centered)}>
      {children}
    </div>
  )
}
